// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".email-page-heading h1{color:#fff}", "",{"version":3,"sources":["webpack://./../../components/partner-purchase-center/pages/email/src/ui/email-page.scss"],"names":[],"mappings":"AAGE,uBACE,UAAA","sourcesContent":["@import '@css-xp/base/assets/css/partials/_base';\n\n.email-page-heading {\n  h1 {\n    color: $N0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
